import { defineStore } from 'pinia';
import { nanoid } from 'nanoid';
import Config from '../config';

export const useTimerStore = defineStore('timerStore', 
{
    state: () =>
    ({
        timers: {} as {[id:string]:number}
    }),

    actions: 
    {
        isScheduled(id:string): boolean
        {
            return this.timers[id] !== undefined;
        },
        schedule(task: Function, args: any[] = [], frequencyInMs:number = 60000, repeat:boolean = true): string
        {
            let func = repeat ? setInterval : setTimeout;

            let id = nanoid();

            // Anything larger will cause the cause the timeout function to run immediately. Useful for local testing tokens that last a very long time.
            frequencyInMs = Math.min(frequencyInMs, Config.MAX_SAFE_32_BIT_INTEGER);

            this.timers[id] = func(task, frequencyInMs, ...args);

            return id;
        },
        unschedule(id:string): void
        {
            let schedule = this.timers[id];

            if(schedule)
            {
                clearInterval(schedule);
                delete this.timers[id];
            }
        },
        unscheduleAll(): void
        {
            for(let id of Object.keys(this.timers))
            {
                this.unschedule(id);
            }
        }
    }
});